/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Delivery_EmailInputs */

const cs_tasks_protocol_delivery_email = /** @type {(inputs: Tasks_Protocol_Delivery_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozvánka e-mailem / SMS`)
};

const en_tasks_protocol_delivery_email = /** @type {(inputs: Tasks_Protocol_Delivery_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email / SMS invite`)
};

/**
* | output |
* | --- |
* | "Email / SMS invite" |
*
* @param {Tasks_Protocol_Delivery_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_delivery_email = /** @type {((inputs?: Tasks_Protocol_Delivery_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Delivery_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_delivery_email(inputs)
	return cs_tasks_protocol_delivery_email(inputs)
});